var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.couponIsAvailable)?_c('router-link',{staticClass:"coupon-banner",attrs:{"to":_vm.route}},[_c('div',[_vm._v(" "+_vm._s(_vm.couponDescription)+" ")]),(_vm.$store.state.coupon.countdown)?_c('span',{staticClass:"countdown"},[_vm._v(" Only "+_vm._s(_vm.$store.state.coupon.countdown)+" left. ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }